import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {errorCodeTranslation} from "../../Apis/ErrorCode";

// Create Work Shift Api's
export const CreateCompanyWorkShift = createAsyncThunk('companyWorkShift/CreateCompanyWorkShift', async (getVal) => {
    const result = await apiInstance
        .post('work-shift-service/create', { name: getVal })
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_created_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });

    const { data, status } = result;
    return { data, status };
});

export const CreateWorkShiftAccess = createAsyncThunk('companyWorkShift/CreateWorkShiftAccess', async (shiftList) => {
    const result = await apiInstance
        .post('work-shift-service/schedule/create-list', shiftList)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_created_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllWorkShifts = createAsyncThunk('companyWorkShift/GetAllWorkShifts', async (getVal) => {
    const result = await apiInstance
        .post('work-shift-service/get-all-pageable', getVal)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const UserWorkSchedule = createAsyncThunk('companyWorkShift/UserWorkSchedule', async (params) => {
    const { id, UsercontractPagination } = params;
    const result = await apiInstance
        .post(`work-shift-service/work/get-all-pageable/by-work-shift-id/${id}`, UsercontractPagination)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const GetAllByWorkShiftId = createAsyncThunk('companyWorkShift/GetAllByWorkShiftId', async (workShiftId) => {
    const result = await apiInstance
        .get(`work-shift-service/work/get-all/by-work-shift-id/${workShiftId}`)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const AddUserWithWorkShiftId = createAsyncThunk('companyWorkShift/AddUserWithWorkShiftId', async (params) => {
    const { id, all_user } = params;
    const result = await apiInstance
        .post(`work-shift-service/work/create-all/by-work-shift-id/${id}`, all_user)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const DeleteUserFromWorkShift = createAsyncThunk('companyWorkShift/DeleteUserFromWorkShift', async (params) => {
    // const { id, delId } = params;

    const result = await apiInstance
        .post(
            // `work-shift-service/work/delete-by-user-id/${delId}/by-work-shift-id/${id}`
            'work-shift-service/work/remove/work-shift-list/to-user-ids',
            params,
        )
        .then(function (response) {
            if (response?.status == 201 || response?.status == 200) {
                toast.success(t('has_been_deleted_successfully').toUpperCase());
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

export const DeleteContractFromWorkShift = createAsyncThunk(
    'companyWorkShift/DeleteContractFromWorkShift',
    async (params) => {
        const result = await apiInstance
            .post('/work-shift-service/contractor-work/remove/work-shift-list/to-contractor-ids', params)
            .then(function (response) {
                if (response?.status == 201 || response?.status == 200) {
                    toast.success(t('has_been_deleted_successfully').toUpperCase());
                }
                return response;
            })
            .catch(function (error) {
                const errorMessage =
                    error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                        ? t(errorCodeTranslation[error.response.data.code])
                        : t('something_went_wrong_2');
                toast.error(errorMessage);
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const DeleteWorkSHiftTime = createAsyncThunk('companyWorkShift/DeleteWorkSHiftTime', async (id) => {
    const result = await apiInstance
        .delete(`work-shift-service/contractor-work/delete-by-id/${id}`)
        .then(function (response) {
            if (response.status == 201 || response.status == 200) {
                toast.success(t('has_been_deleted_successfully'));
            }
            return response;
        })
        .catch(function (error) {
            const errorMessage =
                error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                    ? t(errorCodeTranslation[error.response.data.code])
                    : t('something_went_wrong_2');
            toast.error(errorMessage);
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});

// details of provider employee
export const UpdateWorkShiftName = createAsyncThunk(
    'companyWorkShift/updateWorkShiftName',
    async (params, { dispatch, getState }) => {
        const result = await apiInstance
            .put('work-shift-service/update-name', params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                const errorMessage =
                    error.response?.data?.code && errorCodeTranslation[error.response.data.code]
                        ? t(errorCodeTranslation[error.response.data.code])
                        : t('something_went_wrong_2');
                toast.error(errorMessage);
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);
